export default __webpack_public_path__ + "search-57d30ccc7a4882d471e9c6510f4a662a.svg";